import React from "react";
import { styled } from "@mui/material/styles";

import { NumericFormat } from "react-number-format";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IconButton, Stack } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import { getDayOfWeek } from "./functions";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: 12,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child th": {
        border: 0,
    },
}));

function JobPlanActivityTable({
    activities = [],
    heading,
    onEdit,
    onDelete,
    isCompleted,
}) {
    const total = activities.reduce(
        (acc, curr) => acc + curr.durationAveragePW,
        0
    );
    return (
        <TableContainer>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell colSpan={3} sx={{ width: "70%" }}>
                            {heading}
                        </StyledTableCell>
                        <StyledTableCell align="center" sx={{ width: "5%" }}>
                            Dur&nbsp;
                        </StyledTableCell>
                        <StyledTableCell align="center" sx={{ width: "5%" }}>
                            Freq
                        </StyledTableCell>
                        <StyledTableCell align="center" sx={{ width: "5%" }}>
                            Av&nbsp;
                        </StyledTableCell>
                        <StyledTableCell>&nbsp;</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {activities.map((row, index) => (
                        <StyledTableRow key={index}>
                            <StyledTableCell sx={{ width: "50%" }}>
                                {row.subcategory.name}
                                {row.onCall && <span> *</span>}
                            </StyledTableCell>
                            <StyledTableCell>
                                {!!row.flexible
                                    ? "- "
                                    : getDayOfWeek(row.scheduled?.dayOfWeek)}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                {!!row.flexible
                                    ? "- - - "
                                    : `${row.scheduled?.start} - ${row.scheduled?.end}`}
                            </StyledTableCell>
                            <StyledTableCell align="right">
                                <NumericFormat
                                    value={row.duration}
                                    decimalSeparator="."
                                    displayType="text"
                                    decimalScale={3}
                                />
                            </StyledTableCell>
                            <StyledTableCell align="right">
                                {row.annualOccurrences}
                            </StyledTableCell>
                            <StyledTableCell align="right">
                                <NumericFormat
                                    value={row.durationAveragePW}
                                    decimalSeparator="."
                                    displayType="text"
                                    decimalScale={3}
                                />
                            </StyledTableCell>

                            <StyledTableCell align="right">
                                {!isCompleted && (
                                    <Stack
                                        direction="row"
                                        justifyContent="flex-end"
                                        spacing={0}
                                    >
                                        <IconButton
                                            aria-label="edit"
                                            onClick={() => onEdit(row)}
                                        >
                                            <EditOutlinedIcon />
                                        </IconButton>
                                        <IconButton
                                            aria-label="delete"
                                            onClick={() => onDelete(row)}
                                        >
                                            <DeleteOutlinedIcon />
                                        </IconButton>
                                    </Stack>
                                )}
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default JobPlanActivityTable;
